import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';

export default function Terms() {
  return (
    <div className="app-container">
      <div className="app-wrapper">
        <div className="app-card legal-page">
          <div className="app-header">
            <h1>
              <Shield className="header-icon" />
              Terms of Service
            </h1>
            <p>Last updated: January 2026</p>
          </div>

          <div className="legal-content">
            <section>
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing or using the Ride Share Checker service ("Service") operated by
                WiredCop LLC ("Company", "we", "us", or "our"), you agree to be bound by these
                Terms of Service. If you do not agree to these terms, do not use the Service.
              </p>
            </section>

            <section>
              <h2>2. Description of Service</h2>
              <p>
                The Service provides vehicle registration lookups and verification against the
                NYC Taxi and Limousine Commission (TLC), Chicago BACP, and other public records.
                The Service is intended for informational purposes only.
              </p>
            </section>

            <section>
              <h2>3. Disclaimer of Accuracy</h2>
              <p>
                <strong>IMPORTANT:</strong> Information provided by the Service is for reference
                only and may not be current or accurate. Data is sourced from third-party databases
                and public records which may contain errors or outdated information. Always verify
                all data through official sources before making any decisions.
              </p>
              <p>
                We make no warranties or representations about the accuracy, reliability,
                completeness, or timeliness of any information provided through the Service.
              </p>
            </section>

            <section>
              <h2>4. Acceptable Use</h2>
              <p>You agree to use the Service only for lawful purposes. You shall not:</p>
              <ul>
                <li>Use the Service for any illegal or unauthorized purpose</li>
                <li>Attempt to gain unauthorized access to our systems or networks</li>
                <li>Use automated tools to scrape or extract data from the Service</li>
                <li>Interfere with or disrupt the Service or servers</li>
                <li>Violate any applicable laws or regulations</li>
                <li>Use the information to stalk, harass, or harm any individual</li>
              </ul>
            </section>

            <section>
              <h2>5. User Accounts</h2>
              <p>
                Some features require account registration. You are responsible for maintaining
                the confidentiality of your account credentials and for all activities under your
                account. You agree to notify us immediately of any unauthorized use.
              </p>
            </section>

            <section>
              <h2>6. Subscription and Payments</h2>
              <p>
                Paid subscriptions are billed on a recurring monthly basis. You may cancel at
                any time through your account settings or the Stripe customer portal. Refunds
                are handled on a case-by-case basis at our discretion.
              </p>
              <p>
                We reserve the right to modify pricing with 30 days notice to existing subscribers.
              </p>
            </section>

            <section>
              <h2>7. Limitation of Liability</h2>
              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, WIREDCOP LLC SHALL NOT BE LIABLE FOR
                ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY
                LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY
                LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES RESULTING FROM:
              </p>
              <ul>
                <li>Your use or inability to use the Service</li>
                <li>Any errors or inaccuracies in the information provided</li>
                <li>Any unauthorized access to or use of our servers</li>
                <li>Any interruption or cessation of the Service</li>
              </ul>
            </section>

            <section>
              <h2>8. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless WiredCop LLC and its officers, directors,
                employees, and agents from any claims, damages, losses, liabilities, and expenses
                arising from your use of the Service or violation of these Terms.
              </p>
            </section>

            <section>
              <h2>9. Modifications to Service</h2>
              <p>
                We reserve the right to modify, suspend, or discontinue the Service at any time
                without notice. We shall not be liable to you or any third party for any
                modification, suspension, or discontinuance of the Service.
              </p>
            </section>

            <section>
              <h2>10. Changes to Terms</h2>
              <p>
                We may update these Terms from time to time. We will notify users of material
                changes by posting the new Terms on this page with an updated "Last updated" date.
                Continued use of the Service after changes constitutes acceptance of the new Terms.
              </p>
            </section>

            <section>
              <h2>11. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of
                the State of New York, without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2>12. Contact Information</h2>
              <p>
                For questions about these Terms, please contact us at:
              </p>
              <p>
                <strong>WiredCop LLC</strong><br />
                Email: legal@wiredcop.com<br />
                Website: <a href="https://wiredcop.com" target="_blank" rel="noopener noreferrer">wiredcop.com</a>
              </p>
            </section>
          </div>

          <div className="legal-footer">
            <Link to="/" className="btn btn-dark">
              <ArrowLeft size={18} /> Back to App
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
